<template>
  <GlobalLoader />
  <router-view /> <!-- Aqui as páginas serão renderizadas -->
</template>

<script>
import GlobalLoader from './components/GlobalLoader.vue'
export default {
  name: 'App',
  components: {
    GlobalLoader
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
@import "./assets/styles/_variables";

* {
  font-family: 'Plus Jakarta Sans', sans-serif;
}

/* Media Queries para responsividade */
@media (max-width: 768px) {
  .fontTitulo {
    font-size: 12px;
    color: $color-secondary;
  }
}

@media (min-width: 769px) and (max-width: 1366px) {

  .fontTitulo {
    font-size: 2rem;
    width: 100%;

    /* M3/display/medium */
    font-family: 'Montserrat', sans-serif;
    font-weight: bold;
    font-style: italic;
    line-height: 52px;
    /* or 116% */
    display: flex;
    align-items: center;
    text-align: center;

    color: $color-secondary;
    /* text-shadow: -3px -3px 4px rgba(0, 0, 0, 0.5); */
  }

}

@media (min-width: 1367px) {
  .fontTitulo {
    /* M3/display/medium */
    font-family: 'Montserrat', sans-serif;
    font-weight: bold;
    font-style: italic;
    line-height: 52px;
    font-size: 45px;
    /* or 116% */
    display: flex;
    align-items: center;
    text-align: center;

    color: $color-secondary;
    /* text-shadow: -3px -3px 4px rgba(0, 0, 0, 0.5); */
  }
}
</style>
